import { MessageDatagram } from "../../models/Dialogs/aiAssistant"
import { MESSAGE_DATAGRAM_TYPE } from "../../store/dialogs/constants"

export class ServiceWorkerCommunicate<T extends unknown> {
    postMessageToSW<S, K extends unknown>(message: MessageDatagram<S>, payloadAddons: Record<string, unknown>) {
        return new Promise<K>((res, rej) => {
            if (!navigator.serviceWorker) {
                return
            }

            navigator.serviceWorker.ready.then(worker => {
                if (!worker.active) {
                    return rej("SW not activated")
                }

                const messageChannel = new MessageChannel()

                worker.active.postMessage(
                    {
                        type: MESSAGE_DATAGRAM_TYPE.PROTO_HANDSHAKE
                    },
                    [messageChannel.port2]
                )

                messageChannel.port1.onmessage = e => {
                    if (!e.data.error) {
                        return res(e.data.payload)
                    }

                    return rej(e.data.error)
                }

                worker.active.postMessage({
                    ...message,
                    payload: {
                        ...message.payload,
                        ...payloadAddons
                    }
                })
            })
        })
    }
}
